<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">lock</mat-icon>
    PERMISSION
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div class="top">
    <div class="row-split">
      <p><strong>{{'User ID' }}: </strong> {{permissionsDetails.fullName}}</p>
      <p><strong>{{'GPID' }}: </strong> {{permissionsDetails.userName}}</p>
      <p><strong>{{'Email' }}: </strong> {{permissionsDetails.emailId}}</p>
      <p><strong>{{'Highest Security Type' }}: </strong> {{permissionsDetails.highestSecurityTypeAsString}}</p>
      <p><strong>{{'Roles' }}: </strong></p>
      <ul>
        <li *ngFor="let i of permissionsDetails.roles">{{i.name}}</li>
      </ul>
    </div>
  </div>

  <div class="bottom">
    <div>
      <mat-card class="admin-tree" style="display: inline-flex;">
        <mat-list *ngIf="!isPermissionsAvailable; else panel"><mat-spinner></mat-spinner></mat-list>
        <ng-template #panel>
          <div *ngIf="isPermissionsAvailable" class="permissions-row-wrapper">
            <div class="permissions-column">
              <span class="permission-header">Business Area</span>
              <div class="permissions-box" style="margin-right: 5px;">
                <ng-container *ngFor="let item of permissionsDetails.objectSecurityGrid.objectSecurityElements">
                  <ng-container *ngIf="item.objectTypeAsString === 'BusinessArea'">
                    <mat-list>
                      <mat-list-item class="queues">
                        <mat-expansion-panel [expanded]="isOpenQueue(item.objectId)">
                          <mat-expansion-panel-header class="queue-panel-header"
                            (click)="getPermissionsQueues(item.objectId)"
                            (keydown)="$event.stopPropagation()">
                            <span>{{ item.objectName }}</span>
                            <span *ngIf="item.canView">(View)</span>
                            <span *ngIf="item.canEdit">(Edit)</span>
                            <mat-icon *ngIf="isOpenQueue(item.objectId)">folder_open</mat-icon>
                            <mat-icon *ngIf="!isOpenQueue(item.objectId)">folder</mat-icon>
                          </mat-expansion-panel-header>
                          <mat-list-item class="p-2" *ngFor="let child of item.childObjectSecurityColl">
                            {{ child.objectName }}
                            <span *ngIf="child.canView">(View)</span>
                            <span *ngIf="child.canEdit">(Edit)</span>
                          </mat-list-item>
                        </mat-expansion-panel>
                      </mat-list-item>
                    </mat-list>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <!-- Work Flows Column -->
            <div class="permissions-column">
              <span class="permission-header">Work Flows</span>
              <div class="permissions-box" style="margin-left: 5px;">
                <ng-container *ngFor="let item of permissionsDetails.objectSecurityGrid.objectSecurityElements">
                  <ng-container *ngIf="item.objectTypeAsString === 'Workflow'">
                    <mat-list>
                      <mat-list-item class="queues">
                        <mat-expansion-panel [expanded]="isOpenQueue(item.objectId)">
                          <mat-expansion-panel-header class="queue-panel-header"
                            (click)="getPermissionsQueues(item.objectId)"
                            (keydown)="$event.stopPropagation()">
                            <span>{{ item.objectName }}</span>
                            <span *ngIf="item.canView">(View)</span>
                            <span *ngIf="item.canEdit">(Edit)</span>
                            <mat-icon *ngIf="isOpenQueue(item.objectId)">folder_open</mat-icon>
                            <mat-icon *ngIf="!isOpenQueue(item.objectId)">folder</mat-icon>
                          </mat-expansion-panel-header>

                          <mat-list-item class="p-2" *ngFor="let child of item.childObjectSecurityColl">
                            {{ child.objectName }}
                            <span *ngIf="child.canView">(View)</span>
                            <span *ngIf="child.canEdit">(Edit)</span>
                          </mat-list-item>
                        </mat-expansion-panel>
                      </mat-list-item>
                    </mat-list>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>